import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import { useAuth } from "./components/AuthContext";


// Pages
import SignInPage from "./components/Signin";
import Home from "./pages/Home";

// Main App Layout
import App from "./App";

// Protected Components
import Stockmanagement from "./components/StockReport";
import DesiStock from "./components/DesiStock";
import DesiStockentry from "./components/DesiStockentry";
import Stock from "./components/Stock";
import EditDesiStockDate from "./components/Editstockwithdate";
import EditStockDate from "./components/Editstockenglishwithdate";
import Boxentryenglish from "./components/Boxentry";
import Boxentrydesi from "./components/Boxentrydesi";
import EdittransferStockDate from "./components/Edittransferstock";
import EdittransferDesiStockDate from "./components/Edittransferstockdesi";
import Boxentrytransfer from "./components/Boxentrytransfer";
import Boxentrydesitransfer from "./components/Boxentrydesitransfer";
import Expense from "./components/Expense";
import Expensedate from "./components/Expensedate";
import Commission from "./components/Comission";
import Commissiondesi from "./components/Commissiondesi";
import Employee from "./components/Employee";
import Creditdebit from "./components/Creditdebit";
import PhonepayCredit from "./components/Phonepaycredit";
import Salesreport from "./components/Salesreport";
import Report from "./components/Report";
import StockManagementReport from "./components/Stockmanagement";
import PrintSlip from "./components/Printslip";
import RateDifference from "./components/RateDifference";
import ProductRateDifference from "./components/ProductRateDifference";
import POS from "./components/POS";


const Router = () => (
  <Routes>
    {/* Public Routes */}
    <Route path="/" element={<Navigate to="/signin" replace />} />
    <Route path="/signin" element={<SignInPage />} />

    {/* Protected App Wrapper */}
    <Route
      path="/"
      element={
        <ProtectedRoute>
          <App />
        </ProtectedRoute>
      }
    >
      {/* Nested Protected Routes */}
      <Route path="home" element={<Home />} />

      <Route path="stockmanagement" element={<ProtectedRoute menuName=" पर्चा"><Stockmanagement /></ProtectedRoute>} />
      <Route path="desistock" element={<ProtectedRoute menuName=" पर्चा"><DesiStock /></ProtectedRoute>} />
      <Route path="desistockentry" element={<ProtectedRoute menuName=" पर्चा"><DesiStockentry /></ProtectedRoute>} />
      <Route path="stock" element={<ProtectedRoute menuName=" पर्चा"><Stock /></ProtectedRoute>} />
      <Route path="editdesistockwithdate" element={<ProtectedRoute menuName="आमद भेजान"><EditDesiStockDate /></ProtectedRoute>} />
      <Route path="editstockwithdate" element={<ProtectedRoute menuName="आमद भेजान"><EditStockDate /></ProtectedRoute>} />
      <Route path="boxenglish" element={<ProtectedRoute menuName="आमद भेजान"><Boxentryenglish /></ProtectedRoute>} />
      <Route path="boxdesi" element={<ProtectedRoute menuName="आमद भेजान"><Boxentrydesi /></ProtectedRoute>} />
      <Route path="edittransferstock" element={<ProtectedRoute menuName="आमद भेजान"><EdittransferStockDate /></ProtectedRoute>} />
      <Route path="editdesitransferstock" element={<ProtectedRoute menuName="आमद भेजान"><EdittransferDesiStockDate /></ProtectedRoute>} />
      <Route path="boxenglishtransfer" element={<ProtectedRoute menuName="आमद भेजान"><Boxentrytransfer /></ProtectedRoute>} />
      <Route path="boxdesitransfer" element={<ProtectedRoute menuName="आमद भेजान"><Boxentrydesitransfer /></ProtectedRoute>} />
      <Route path="expense" element={<ProtectedRoute menuName="खर्च"><Expense /></ProtectedRoute>} />
      <Route path="expensedate" element={<ProtectedRoute menuName="खर्च"><Expensedate /></ProtectedRoute>} />
      <Route path="commission" element={<ProtectedRoute menuName="खर्च"><Commission /></ProtectedRoute>} />
      <Route path="commissiondesi" element={<ProtectedRoute menuName="खर्च"><Commissiondesi /></ProtectedRoute>} />
      <Route path="employee" element={<ProtectedRoute menuName="खर्च"><Employee /></ProtectedRoute>} />
      <Route path="creditdebit" element={<ProtectedRoute menuName="खर्च"><Creditdebit /></ProtectedRoute>} />
      <Route path="phonepaycredit" element={<ProtectedRoute menuName="खर्च"><PhonepayCredit /></ProtectedRoute>} />
      <Route path="salesreport" element={<ProtectedRoute menuName="रिपोर्ट"><Salesreport /></ProtectedRoute>} />
      <Route path="expensereport" element={<ProtectedRoute menuName="रिपोर्ट"><Report /></ProtectedRoute>} />
      <Route path="report" element={<ProtectedRoute menuName="रिपोर्ट"><StockManagementReport /></ProtectedRoute>} />
      <Route path="printslip" element={<ProtectedRoute menuName="प्रिंट"><PrintSlip /></ProtectedRoute>} />
      <Route path="ratedifference" element={<ProtectedRoute menuName="खर्च"><RateDifference /></ProtectedRoute>} />
      <Route path="productratedifference" element={<ProtectedRoute menuName="खर्च"><ProductRateDifference /></ProtectedRoute>} />
      <Route path="pos" element={<POS />} />

    </Route>
  </Routes>
);

export default Router;
